var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
function handleCssComposes(exports, composes) {
	for (var i = 0; i < composes.length; i += 3) {
		var moduleId = composes[i];
		var composeFrom = composes[i + 1];
		var composeVar = composes[i + 2];
		var composedId = __webpack_require__(composeFrom)[composeVar];
		exports[moduleId] = exports[moduleId] + " " + composedId
	}
}
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");
if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}

link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}


	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	if (hmr && hmr.getAttribute("fetchpriority")) link.setAttribute("fetchpriority", hmr.getAttribute("fetchpriority"));
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([0bp]|0x|1r|1s|4p|a2g|ef|ft|hm|j3|otj|qe|qi)|n([037bdiq]|23|2u|57|95|c5|jx|ml|ya|ze)|2(57|5k|77|7y|8|ci|d6|g3|hd|k4|zm)|f([46lmrx]|w[bin]|2j|4t|bm|d3|n7|ob|pr|sl|to|tw|vi)|q([14bevw]|4j|g9e|j7|k4|mc|tf|v0|x6)|w([7agjs]|0q|1v|57|a6|cf|ry|v4|wb)|z([0amtw]|51|bi|dw|f4|gc|me|mu|x5)|o([8di]|15|4n|dj|f6|fo|hu|uh|uz|wz|xn|za|zc)|k([3fm]|ya(|a)|1f|1z8|4h|54|89|q9|r2|zb)|d([5einrz]|30|cm|f6|gb|km|nc|pi|v7)|l(9|b0|cd|d|h5|iy|u0|ym)|7([aduw]|2a|2d|5z|86|a2|fa|gn|ie|j1|r1)|b(3t|84|am|kn|n|oc|sc|vx|xt|z)|9([3glpq]|65|87|8h|9u|am|be|e6|j2|kb|ls|mq|og|p9)|r([9gj]|02|7a|9f|hk|ku|n6|oo|q7|xd|zx)|0([9dfgj]|1[5kq]|[aip]g|4y|5q|aj|bc|fi|q9|vb|xz|yx)|t([cdn]|l(3|7|lv)|3a|3w|51|7lm|a6|ah|gm|ii|n9|qs|ue)|i([5iou]|r[4iz]|10|4i|4z|99|a2|ap|b6|c0|gs|k4|kr|lw|nj|ns)|x([9djlsyz]|2y|4x|bv|gd|hy|mx|rh|yc|zc)|h([126ex]|a[58o]|4b|4c|cx|g2|gj|j6|t8|up|wz|ya|yz)|j([5hipq]|29|4f|7g|a4|dp|dv|vb|wb|wf)|3([1elz]|71|92|fl|j3|r4|wj)|s([37bcgr]|0a|61|d9|ex|he|hs|kd|kj|lp|me|tz|vp)|v([69ans]|k[dhn]|b3|ct|fa|fg|og)|1([1789fiow]|00|96|f1|i1|iz|jf|mh|mu|rv|x7)|8([ehjqwx]|1s|2x|e8|es|gu|hi|k2|nm|ov|qc|w4)|g(11|9s|l|t6|x|yb|yf|zt)|p([2dlrs]|2k|3x|6o|n8|nt|yv)|4([hnv]|7[6eh]|17|1h|2a|bi|eg|ft|lm|uu|v5)|a([2fw]|[cgi]k|3u|7h|7y|9o|cv|d3|do|eb|jn|k3|rf)|5([045muz]|0s|1p|6n|6p|gc|kk|rd|s9)|c([348]|23|4t|8a|kc|mi|n9)|6([3eoquvwy]|19|3t|8y|96|cd|co|fq|gc|v8|vyp|wc|zy)|u([8ky]|2l|dt|gm|hn|u8|w8|wq)|e([5fltw]|2b|2f|5l|98|ah|av|jg|l9|mz|r0|tk3|vi|vw|wo)|y([jxy]|2q|7n|ek|kp|kw|l8))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
